import { RootState, SetState } from '@/store/useStore.ts';
import { defaultTimerState, TimerSlice } from '@/store/slices/timer/types';

export type { TimerSlice };

export const timerSlice = ({ set }: SetState<RootState>): TimerSlice => ({
  ...defaultTimerState,
  setCurrentTime: (time: string) =>
    set(
      (state) => ({ ...state, currentTime: time }),
      false,
      'timer/setCurrentTime',
    ),
  setSessionTime: (time: string) =>
    set(
      (state) => ({ ...state, sessionTime: time }),
      false,
      'timer/setSessionTime',
    ),
  setGameTime: (time: string) =>
    set((state) => ({ ...state, gameTime: time }), false, 'timer/setGameTime'),
  setServerTimeValue: (time: number) =>
    set(
      (state) => ({ ...state, serverTimeValue: time }),
      false,
      'timer/setServerTimeValue',
    ),
  setSessionStartValue: (time: number) =>
    set(
      (state) => ({ ...state, sessionStartValue: time }),
      false,
      'timer/setSessionStartValue',
    ),
  setGameStartValue: (time: number) =>
    set(
      (state) => ({ ...state, gameStartValue: time }),
      false,
      'timer/setGameStartValue',
    ),
  resetGameTime: () =>
    set(
      (state) => ({
        ...state,
        gameTime: '00:00:00',
        gameStartValue: undefined,
      }),
      false,
      'timer/resetGameTime',
    ),
});
